import { createSelector } from 'reselect'
import { logUtil, getObjectUtil } from 'packages/src'

function getCurrentReduxSelector (domainMapPath, domainCurrentPath) {
  return createSelector(
    state => getObjectUtil(state, domainMapPath),
    state => getObjectUtil(state, domainCurrentPath),
    (domainMap, id) => {
      if (!domainMap) {
        const debugProps = {
          domainMapPath,
          domainCurrentPath
        }
        logUtil('getCurrentReduxSelector').warn('domainMap is not defined debugProps=', debugProps)
      }
      return domainMap?.[id]
    }
  )
}

export default getCurrentReduxSelector
